export default "__VITE_ASSET__DxsTI6pl__"